import { api } from 'constants/constant';
import { getHeaders } from 'auth/auth';
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const loanProcessorAPI = createApi({
  reducerPath: 'loanProcessor',
  baseQuery: fetchBaseQuery({ baseUrl: api, credentials: 'include' }),
  endpoints: (builder) => ({
    getLoanProcessors: builder.query({
      query: ({ pageNumber, pageSize }) => ({
        url: `/b2b/loan/employee/?role=loan_processor&page_number=${pageNumber}&page_size=${pageSize}`,
        method: 'GET',
        headers: getHeaders(),
      }),
      transformResponse: (response) => {
        if (response) {
          return response;
        }
      },
    }),
  }),
});

export const { useGetLoanProcessorsQuery } = loanProcessorAPI;
